import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import homeRouter from "./homeRouter";
import adminhomeRouter from "./adminhomeRouter";

const routes = [
  {
    path: "/",
    redirect: "/orghome",
  },
  {
    path: "/admin",
    redirect: "/adminhome",
  },
  {
    path: "/adminlogin",
    component: () => import("../views/orglogin/adminlogin"),
    meta: {
      title: "登录",
      needLogin: false,
    },
  },
  {
    path: "/orglogin",
    component: () => import("../views/orglogin/login"),
    meta: {
      title: "登录",
      needLogin: false,
    },
  },
  {
    path: "/orgregister",
    component: () => import("../views/orglogin/register"),
    meta: {
      title: "注册",
      needLogin: false,
    },
  },
  {
    path: "/orgfindpass",
    component: () => import("../views/orglogin/findpass"),
    meta: {
      title: "找回密码",
      needLogin: false,
    },
  },
  {
    path: "/formsub",
    component: () => import("../views/orglogin/formsub"),
    meta: {
      title: "项目申报",
      needLogin: true,
    },
  },
  {
    path: "/project_formsub",
    component: () => import("../views/orglogin/project_formsub"),
    meta: {
      title: "项目申报",
      needLogin: true,
    },
  },
  {
    path: "/detail",
    component: () => import("../views/orglogin/detail"),
    meta: {
      title: "项目公告",
      needLogin: true,
    },
  },
  {
    path: "/table",
    component: () => import("../views/orglogin/table"),
    meta: {
      title: "预览",
      needLogin: true,
    },
  },
  {
    path: "/orghome",
    component: () => import("../views/orghome/home"),
    children: homeRouter,
  },
  {
    path: "/adminhome",
    component: () => import("../views/adminhome/home"),
    children: adminhomeRouter,
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

// const VueRouterPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(to) {
//   return VueRouterPush.call(this, to).catch(err => err)
// }
//
// router.beforeEach((to, from, next) => {
//   // 因为导航守卫会比 created 更早触发，所以要先获取本地数据
//   let paths = to.path.split('/')
//   let index = paths.indexOf('adminhome')
//   let admintoken = window.localStorage.getItem('admintoken')
//   let shzztoken = window.localStorage.getItem('shzztoken')
//   console.log("admintoken")
//   console.log(admintoken)
//   if(index != -1) {
//     if(to.meta.needLogin && admintoken) {
//       console.log(1111)
//       next()
//     }else {
//       console.log(2222)
//       next({
//         path: `/adminlogin`,
//         params: to.params,
//         query: to.query
//       })
//     }
//   }else {
//     if(to.meta.needLogin && shzztoken) {
//       next()
//     }else {
//       next({
//         path: `/orglogin`,
//         params: to.params,
//         query: to.query
//       })
//     }
//   }
//
// });

export default router;
